import { render, staticRenderFns } from "./WorkComponents.vue?vue&type=template&id=48550973&scoped=true&"
import script from "./WorkComponents.vue?vue&type=script&lang=js&"
export * from "./WorkComponents.vue?vue&type=script&lang=js&"
import style0 from "./WorkComponents.vue?vue&type=style&index=0&id=48550973&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48550973",
  null
  
)

export default component.exports